export default "__VITE_ASSET__BGJWXIn5__"